import { OrganizationKeyName } from "../../../model/Organization";
import { ShopProductAdditionsListItem } from "../model/ShopProductAdditionsListSuccessResponse";

export const GET_PRODUCT_ADDITION_LIST_SUCCESS =
  "SHOP:GET_PRODUCT_ADDITION_LIST_SUCCESS";

export const getProductAdditionListSuccessAction = (
  organization: OrganizationKeyName,
  data: ShopProductAdditionsListItem[]
) => ({
  type: GET_PRODUCT_ADDITION_LIST_SUCCESS as typeof GET_PRODUCT_ADDITION_LIST_SUCCESS,
  organization,
  data,
});

export type GetProductAdditionListSuccessAction = ReturnType<
  typeof getProductAdditionListSuccessAction
>;
